import React, { useState, useContext} from 'react';
import {Link} from 'react-router-dom'
import ChangePassword from '../ChangePassword';
import {Context}from '../../../../contexts/Account'
function SiderBar() {
    const [changePass, setChangePass] = useState(false);
    const { onLogoutAccount } = useContext(Context);
    const handleModal=()=>{
        setChangePass(true)
    }
    const HandleLogout = () => {
        onLogoutAccount();
    }
    return (
        <div className="siderBar">
            <ul>
                <li><Link to="/profile/my-booking"><img className="img-fluid" src="/images/ic_room.png" alt="" />Đặt phòng của tôi</Link></li>
                <li><Link to="/profile/personal-document"><img className="img-fluid" src="/images/ic_document.png" alt="" />Thông tin giấy tờ</Link></li>
                <li><Link to="/profile/bill"><img className="img-fluid" src="/images/ic_bill.png" alt="" />Thông tin xuất hóa đơn</Link></li>
                <li><Link onClick={handleModal}><img className="img-fluid" src="/images/ic_social.png" alt="" />Đổi mật khẩu</Link></li>
                <li><Link onClick={HandleLogout} to="/"><img className="img-fluid" src="/images/ic_leave.png" alt="" />Đăng xuất</Link></li>
                </ul>
            <ChangePassword changePass={changePass} setChangePass={setChangePass}/>
        </div>
    );
}
export default SiderBar;